// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserProfile_wrapper__1DYTv","title":"UserProfile_title__2bcpO","info":"UserProfile_info__3hK82","btn":"UserProfile_btn__3FxMs"};